module.exports = __webpack_public_path__ + "static/media/logo_img_dark.875171d8.gif";